"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationRequestCondition = void 0;
var NotificationRequestCondition;
(function (NotificationRequestCondition) {
    NotificationRequestCondition["CLASS_HAS_PAST_SLOTS"] = "CLASS_HAS_PAST_SLOTS";
    NotificationRequestCondition["NO_SCHEDULED_SLOTS"] = "NO_SCHEDULED_SLOTS";
    NotificationRequestCondition["UPCOMING_SLOT"] = "UPCOMING_SLOT";
})(NotificationRequestCondition = exports.NotificationRequestCondition || (exports.NotificationRequestCondition = {}));
//# sourceMappingURL=notification-request-event.js.map